import LogoutIcon from '../../assets/icons/logout.svg?react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../types';
import { LogoutCommand } from '../../core/authentication/LogoutCommand';
import { FC, useCallback } from 'react';
import styled from 'styled-components';
import { ButtonIcon } from '../legacy/style';

export const IconButtonOverride = styled(ButtonIcon).attrs({ size: '15px' })`
    display: inline;
    width: 33.5px;
    height: 33.5px;
    border-radius: 8px;
    margin-left: unset;
    margin-right: unset;
    color: ${({ theme }) => theme.color.white.main};
    background-color: ${({ theme }) => theme.color.blue.primary};
    padding: 0;
    &.active {
        background-color: ${({ theme }) => theme.color.white.main} !important;
        color: ${({ theme }) => theme.color.blue.primary};

        svg {
            opacity: 1;
            color: ${({ theme }) => theme.color.blue.primary};
        }
    }

    &:hover {
        background-color: ${({ theme }) => theme.color.blue.light} !important;
        color: ${({ theme }) => theme.color.blue.medium};

        svg {
            opacity: 1;
            color: ${({ theme }) => theme.color.blue.medium};
        }
    }
`;

export const LogoutIconButton: FC = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const handleLogout = useCallback(() => dispatch(LogoutCommand()), []);

    return (
        <IconButtonOverride title={t('labels.logout')} onClick={handleLogout}>
            <LogoutIcon />
        </IconButtonOverride>
    );
};
